import React from 'react';
import classnames from 'classnames/bind';
import { isEmpty } from 'lodash';
import { Button } from 'tuui';
import { useMultiLayerPathParams } from 'modules/multi-layer-drawer/hooks/useMultiLayerPathParams';
import { ReactComponent as ChatAgentIcon } from 'modules/onboarding/OnboardingChatForm/components/InitWidget/welcome-message-icon.svg';
import { APP_EVENT_TYPE } from 'modules/taboola-common-frontend-modules/app-events-aggregator/appEventType';
import { useAppEventContext } from 'modules/taboola-common-frontend-modules/app-events-aggregator/hooks/useAppEventContext';
import { useChatAgentContext } from 'modules/taboola-common-frontend-modules/chat-agent/hooks/useChatAgentContext';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { useChatAgentPermitted } from '../../hooks/useChatAgentPermitted';
import styles from './chatAgentButtonBase.module.scss';

const classNameBuilder = classnames.bind(styles);

export const ChatAgentButtonBase = ({ eventType, eventData, id, messageId, className, isCompactMode, triggerName }) => {
    //ToDo: merge messageId with id once chat agent is updated
    const { formatMessage } = useIntl();
    const { push: pushAppEvent } = useAppEventContext();
    const { openChat } = useChatAgentContext();
    const isChatAgentPermitted = useChatAgentPermitted();
    const { data: formData } = useFormDataContext();
    const { entity } = useMultiLayerPathParams();
    const pushAppFormdata = isEmpty(formData) || !entity ? undefined : { [entity]: formData };
    const userMessage = formatMessage({
        id: `user.message.${messageId}`,
        defaultMessage: 'I want to consult with Abby',
    });
    const displayText = formatMessage({
        id: messageId,
        defaultMessage: 'Consult with Abby',
    });

    const handleClick = () => {
        pushAppEvent({
            id,
            triggerName,
            displayText,
            type: eventType || APP_EVENT_TYPE.CLICK,
            data: eventData || pushAppFormdata,
        });
        openChat({ userMessage });
    };

    if (!isChatAgentPermitted) {
        return null;
    }

    return (
        <div className={classNameBuilder('container', className)}>
            <Button className={classNameBuilder('button', { compact: isCompactMode })} onClick={handleClick}>
                <div className={styles['button-content']}>
                    <ChatAgentIcon alt="abby-icon" className={styles['chat-agent-icon']} />
                    <div className={classNameBuilder('text', { hidden: isCompactMode })}>
                        <span>{displayText}</span>
                    </div>
                </div>
            </Button>
        </div>
    );
};
